import React, { useState } from 'react';

function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [comments, setComments] = useState('');
  const [subscribe, setSubscribe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = { name, email, comments, subscribe };

    try {
      const response = await fetch("http://localhost:3000/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        alert("Thank you for your submission!");
        setName("");
        setEmail("");
        setComments("");
        setSubscribe(false);
      } else {
        alert("Your form was not submitted :( please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Your form was not submitted :( please try again later.");
    }
  }; 

  return (
    <>
      <h2>Contact Us</h2>
      <h4>Subscribe to our mailing list using the secure form below:</h4>
      <form onSubmit={handleSubmit}>
        <fieldset>
          <legend>Your Details</legend>

          {/* Name Input */}
          <label>
            Please enter your name:
            <input
              type="text"
              name="name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
          </label>
          <br />

          {/* Email Input */}
          <label>
            Email Address:
            <input
              type="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </label>
          <br />

          {/* Comments Section */}
          <label>
            Comments:
            <textarea
            name="comments"
              value={comments}
              onChange={e => setComments(e.target.value)}
              rows="4"
              placeholder="Enter your message..."
            />
          </label>
          <br />

          {/* Mailing List Checkbox */}
                <label className="checkbox-label">
                Add me to the mailing list:
                <input type="checkbox" checked={subscribe} onChange={(e) => setSubscribe(e.target.checked)} />
                </label>
                <br />
          <button type="submit">Submit</button>

        </fieldset>
      </form>
    </>
  );
}

export default ContactPage;